var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("tool-bar", { attrs: { title: "Submission History" } }),
      _vm._v(" "),
      _c(
        "v-container",
        [
          _vm.submissionArray && _vm.submissionArray.length
            ? _vm._l(_vm.submissionArray, function(submission, index) {
                return _c(
                  "v-flex",
                  { key: index, class: { "light-gray-bg": index % 2 !== 0 } },
                  [
                    submission && submission.licenseAttestFlag === false
                      ? _c(
                          "v-alert",
                          {
                            staticClass: "mb-2",
                            staticStyle: { "margin-bottom": "1rem" },
                            attrs: {
                              type: "warning",
                              icon: "warning",
                              variant: "outlined",
                              value: true
                            }
                          },
                          [
                            _vm._v(
                              "\n          This service log is pending submission. Please select the Provider Signature to complete and submit the log.\n        "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("history-repeatable", {
                      attrs: { submission: submission },
                      on: { "service-log:deleted": _vm.getSubmissionArray }
                    })
                  ],
                  1
                )
              })
            : [
                _c("v-flex", { staticClass: "font-italic" }, [
                  _vm._v("\n        No Submissions, click\n        "),
                  _c(
                    "span",
                    {
                      staticClass: "blue--text",
                      staticStyle: { cursor: "pointer" },
                      on: { click: _vm.goHome }
                    },
                    [_vm._v("\n          here\n        ")]
                  ),
                  _vm._v("\n        to return to the dashboard.\n      ")
                ])
              ]
        ],
        2
      ),
      _vm._v(" "),
      _c("bottom-nav")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a5a7e03", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a5a7e03","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service-log/history/history-container/history-container.vue
// module id = null
// module chunks = 